import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
export const BlockDisclosure = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box sx={{
      p: 2,
      lineHeight: 1.03,
      bgcolor: "grey.100",
      color: "text.secondary"
    }}><Typography variant="textExtraSmall" color="grey.600" data-testid="editorialSubText">Many or all of the products on this page are from partners who compensate us when you click to or take an action on their website, but this does not influence our evaluations or ratings. Our opinions are our own.</Typography></Box>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};